import React from "react";
import parse from "html-react-parser";

import { Text, VStack, Flex } from "@sqymagma/elements";
import { getNewsPublishedLabel } from "@helpers";

import * as S from "./style";

const NewsItem = (props: Props) => {
  const { newsText, start } = props;
  const publishedLabel = getNewsPublishedLabel(start) ?? "New";

  return (
    <S.NewsWrapper className="newsWrapper">
      <VStack>
        <Flex alignItems="center" mb="xxs">
          <S.Bullet />
          <Text textStyle="tiny" style={{ fontWeight: 500, fontSize: 12 }}>
            {publishedLabel}
          </Text>
        </Flex>
        <Text textStyle="body">{parse(newsText)}</Text>
      </VStack>
    </S.NewsWrapper>
  );
};

interface Props {
  newsText: string;
  start?: string;
}

export default NewsItem;
